import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import TotalEnduroCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalEnduroCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const TotalEnduroPage = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()

  return (
    <>
      <CardTitle
        title="Total Enduro por compañía"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <TotalEnduroCard {...props} />
    </>
  )
}

export default memo(TotalEnduroPage)
